import config from "../../../config";
import makeAPIRequest from "../../../services/makeRequest";

async function getImpactStats(marketstats, accessToken, year = null) {
  let API_ENDPOINT = `${config["API_BASE_ENDPOINT"]}/admin/impactdashboard/marketstats/${marketstats}`;
  if (year) {
    API_ENDPOINT += `?year=${year}`;
  }

  const response = await makeAPIRequest(API_ENDPOINT, "GET", null, accessToken);
  const jsonResponse = await response.json();
  return jsonResponse;
}

export default getImpactStats;
